import {PurchaseDetailM} from "./purchase_detail.model";
import {UserM} from "./user.model";
import {ShipRateM} from "./user_shipping_rate.model";
import {PaymentM} from "./payment";

export class PurchaseM{
  id:number = 0
  type:string = "quotation"
  type2_id:number = 0
  type2_name = ""
  detail_type:string = "product"
  consign_type:string = "consign"
  branch_id:number = 0
  branch_name:string = ""
  payment_term:string = ""
  no:string = ""
  ref_bill_no:string = ""
  ref_purchase_id:number = 0
  ref_purchase_no:string = ""
  ref_customer_no:string = ""
  tag:string = ""
  status:string = "pending"
  status_payment:string = "waiting"
  cost:number = 0
  handle_cost:number = 0
  cost_total:number = 0
  cost_total_baht:number = 0
  price_total:number = 0
  price_total_baht:number = 0

  profit:number = 0
  profit_baht:number = 0
  price_settle_percent1:number = 30
  price_settle_percent2:number = 70
  price_settle1:number = 0
  price_settle2:number = 0
  price_settle1_baht:number = 0
  price_settle2_baht:number = 0
  qty_total = 0
  shipping_cbm_total = 0
  shipping_kg_total = 0
  qty_check_total = 0
  qty_remain_check_total = 0
  debit:number = 0
  currency = "cny"
  currency_rate = 0
  currency_rate1 = 0.0
  currency_rate2 = 0.0
  credit:number = 0
  user_no:string = ""
  user_id:number = 0
  sales_id:number = 0
  sales_no = ""
  sales_name = ""
  shipping_id:number = 0
  shipping_name = ""
  shipping_ref_no = ""
  seller:UserM = new UserM()
  person_id:number = 0
  sell_style:string = ""
  address:string = ""
  store_name:string = ""
  shipping_no:string = ""
  shipping_type:string = ""
  shipping_brand:Boolean = false
  shipRates: Array<ShipRateM> = []
  short_detail:string = ""
  firstname:string = ""
  lastname:string = ""
  tax_no:string = ""
  email:string = ""
  phone:string = ""
  mobile:string = ""
  fax:string = ""
  biv_date:string = ""
  start_date:string = ""
  end_date:string = ""
  created_at:string = ""
  updated_at:string = ""
  details: Array<PurchaseDetailM> = []
  payments:Array<PaymentM> = []
  details_original: Array<PurchaseDetailM> = []
  details_exist:Boolean = false
  selected:Boolean = false
  remark:string = ""
  balance:0



}



// WEBPACK FOOTER //
// ./src/app/model/purchase.model.ts